if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener("product-info:loaded", ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        document.querySelector("html").classList.remove("overflow-hidden");

        const cartNotification =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        document.querySelector("html").classList.add("overflow-hidden");
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener.querySelector(".loading__spinner").classList.remove("hidden");

        fetch(opener.getAttribute("data-product-url"))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const productElement = responseHTML.querySelector("product-info");

            this.preprocessHTML(productElement);
            this.additionalPreprocessHTML(productElement);
            this.updatePriceDisplay(productElement);
            HTMLUpdateUtility.setInnerHTML(
              this.modalContent,
              productElement.outerHTML,
            );

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      updatePriceDisplay(productElement) {
        const priceContainers = productElement.querySelectorAll(
          ".dollarlabs_pricelist--product_price",
        );
        if (priceContainers.length === 0) return;
        priceContainers.forEach((priceContainer) => {
          priceContainer.classList.add("quick-add-price");
        });
      }

      additionalPreprocessHTML(productElement) {
        // add See Details button
        const buttonsContainer = productElement.querySelector(
          ".product-form__quantity",
        );

        if (buttonsContainer) {
          const viewDetailsLink = document.createElement("a");
          viewDetailsLink.href = productElement.getAttribute("data-url");
          viewDetailsLink.className = "pd-button pd-button--ghost ";
          viewDetailsLink.textContent = "see details";
          buttonsContainer.after(viewDetailsLink);
        }

        // add rating snippet
        const ratingContainer = productElement.querySelector(
          "reviewsio-product-ratings",
        );
        if (ratingContainer) {
          const ratingSnippet = document.createElement("script");
          ratingSnippet.defer = true;
          ratingSnippet.textContent = `
              if (typeof ratingSnippet !== 'undefined') {
                ratingSnippet('ruk_rating_snippet', {
                  store: 'carusosnaturalhealth.com.au',
                  mode: 'default',
                  color: '#306671',
                  linebreak: false,
                  text: 'Reviews',
                  singularText: 'Review',
                  lang: 'en',
                  usePolaris: false,
                  showEmptyStars: false,
                });
              }
          `;
          ratingContainer.appendChild(ratingSnippet);
        }

        const submitBtn = productElement.querySelector('button[type="submit"]');
        if (submitBtn) {
          submitBtn.classList.remove("hidden");
        }

        // Remove video slides on mobile
        this.removeVideoSlides(productElement);
      }

      removeVideoSlides(productElement) {
        const productMedia = productElement.querySelector(
          ".product__media-wrapper",
        );
        if (!productMedia || window.innerWidth >= 989) return;

        // Find all swiper slides containing deferred-media
        const videoSlides = Array.from(
          productMedia.querySelectorAll(".swiper-slide"),
        ).filter((slide) => slide.querySelector("deferred-media"));

        // Remove each video slide
        videoSlides.forEach((slide) => {
          slide.remove();
        });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith("color-") || classApplied === "gradient")
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector(
          "pickup-availability",
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector("product-modal");
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll("modal-dialog");
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(
          oldId,
          newId,
        );
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(
              attribute.name,
              attribute.value.replace(oldId, newId),
            );
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector(
          '[id^="Slider-Gallery"]',
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector(".product");
        const desktopColumns = product?.classList.contains("product--columns");
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let mediaImageSizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

        if (product.classList.contains("product--medium")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "495px");
        }

        mediaImages.forEach((img) =>
          img.setAttribute("sizes", mediaImageSizes),
        );
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute("data-update-url", "false");
      }
    },
  );
}
